<div class="membership-payment">
  <div class="payment-card flex">
    <div class="payment-img flex-col-pay flex">
      <img [src]="images?.LOCKED" class="wd-100-hg-100" alt="close" />
    </div>
    <div class="payment-action flex-col-pay flex">
      <div class="action-heading">
        {{ 'YOUR_SYSTEM_LOCKED' | fallbackTranslate }}
        <span class="red-text fw-600">{{ 'LOCKED' | fallbackTranslate }}</span>
      </div>
      <div class="key-info">
        {{ 'YOUR_UNPAID_BALANCE' | fallbackTranslate }}
        <span class="fw-600"
          >{{ currency }} {{ paymentDetails?.finalBill_text }}</span
        >
        {{ 'FOR_THE_MONTH_OF' | fallbackTranslate }}
        <span class="fw-600">{{ currentMonth }}</span>
        {{ 'IS_DUE' | fallbackTranslate }}
      </div>
      <div class="key-info">
        <span class="fw-600">{{ 'PAY_NOW' | fallbackTranslate }}</span>
        {{ 'TO_UNLOCK_YOUR_SYSTEM' | fallbackTranslate }}
      </div>
      <div class="key-info">
        <a class="new-colour" (click)="download()" [class.loading]="isLoading">
          <img [src]="images?.DOWNLOAD" class="img-14 m-r-5" alt="close" />
          {{ 'DOWNLOAD_DETAILS' | fallbackTranslate }}
        </a>
      </div>
      <div class="action-button wd-100 flex-space flex m-12">
        <button
          nz-button
          nzType="primary"
          nzGhost
          class="wd-100 flex-1 talk-to-expert-button"
          nzSize="large"
          (click)="talkToExpert()"
        >
          {{ 'TALK_TO_EXPERT' | fallbackTranslate }}
        </button>
        <button
          nz-button
          nzType="primary"
          class="wd-100 flex-1 bg-button"
          nzSize="large"
          (click)="askForReocurrInfoandPay()"
        >
          {{ 'PAY_NOW' | fallbackTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
